export const PLATFORMS = ['whatsapp', 'signal'];
export const BACKUP_TRANSLATION_PROVIDERS = ['index35b', 'bing', 'index2b'];
export const TRANSLATION_PROVIDERS = ['google', 'deepl', 'hunyuan', 'qwen', 'ai', 'aai', ...BACKUP_TRANSLATION_PROVIDERS];
export const TRANSLATION_PROVIDER_LABELS = {
    google: '谷歌模型', deepl: 'DeepL模型', hunyuan: '混元模型',
    qwen: '千问模型', ai: '阿里AI模型', aai: '腾讯AI模型',
    index35b: 'Index-Translate-35B', bing: 'Bing legacy', index2b: 'Index-Translate-2B'
};
export function isBackupTranslationProvider(value) {
    return typeof value === 'string' && BACKUP_TRANSLATION_PROVIDERS.includes(value);
}
export const DEEPL_MODEL_TYPES = [
    'latency_optimized',
    'quality_optimized',
    'prefer_quality_optimized'
];
export function isPlatform(value) {
    return typeof value === 'string' && PLATFORMS.includes(value);
}
export function isTranslationProvider(value) {
    return typeof value === 'string'
        && TRANSLATION_PROVIDERS.includes(value);
}
export const ADMIN_PERMISSIONS = [
    'overview.read',
    'users.read',
    'users.write',
    'licenses.read',
    'licenses.write',
    'devices.read',
    'devices.write',
    'translation.read',
    'translation.write',
    'usage.read',
    'releases.read',
    'releases.write',
    'audit.read',
    'system.read'
];
//# sourceMappingURL=index.js.map